<section class="services-final-cta dingo-section dingo-bg-accent">
  <div class="container">
    <aside class="services-final-card reveal-on-scroll" data-reveal="card">
      <p class="services-kicker">Siguiente paso</p>
      <h2>Armemos el stack de crecimiento para <span class="highlight-green">tu negocio</span></h2>
      <p>Cuéntanos tu objetivo y definimos qué servicios, canales y tecnología necesitas activar primero.</p>
      <a class="dingo-cta-primary" routerLink="/contacto">
        Contactar equipo
        <i class="bi bi-arrow-up-right"></i>
      </a>
    </aside>
  </div>
</section>
